import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { PUserMenuItem } from './helpers';
import { BaseTypography } from 'src/components/common';

const useStyles = makeStyles(() => ({
  menuItem: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '1fr 20px',
    gridGap: '5px',
    paddingTop: 14,
  },
  menuItem__label: {
    whiteSpace: 'nowrap',
  },
}));

export const MobileMenuItem: React.FC<PUserMenuItem> = (props) => {
  const { item, isActive = false } = props;
  const classes = useStyles({ isActive });
  return (
    <div className={classes.menuItem}>
      <BaseTypography className={classes.menuItem__label}>
        {item.label}
      </BaseTypography>
      <item.ico />
    </div>
  );
};
